import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section id="home" className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-101">
      {/* Background Image with Parallax feel */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat bg-fixed" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/kUyKmd1Ts2QeFtMtYHGkwn/IMG_4088.jpg")'
    }} data-id="element-102" />

      {/* Dark Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900 via-charcoal-900/60 to-charcoal-900/30" data-id="element-103" />
      <div className="absolute inset-0 bg-black/20" data-id="element-104" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full flex flex-col items-center text-center mt-20" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={{
        opacity: 1,
        scaleX: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="w-16 md:w-24 h-[1px] bg-gold mb-8 origin-center" data-id="element-106" />

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="font-heading text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-cream mb-6 leading-tight max-w-5xl" data-id="element-107">
          {t.hero.heading1} <br className="hidden md:block" data-id="element-108" />
          <span className="italic text-gold" data-id="element-109">{t.hero.heading2}</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-xl md:text-2xl text-cream/90 max-w-3xl mb-12 font-light leading-relaxed" data-id="element-110">
          {t.hero.subtitle}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="flex flex-col sm:flex-row items-center gap-6" data-id="element-111">
          <a href="#prodej" className="px-8 py-4 bg-gold text-charcoal-900 text-sm tracking-widest uppercase font-semibold hover:bg-gold-hover transition-colors duration-300 w-full sm:w-auto text-center" data-id="element-112">
            {t.hero.cta1}
          </a>
          <a href="#pronajem" className="px-8 py-4 border border-gold text-gold text-sm tracking-widest uppercase font-semibold hover:bg-gold hover:text-charcoal-900 transition-colors duration-300 w-full sm:w-auto text-center" data-id="element-113">
            {t.hero.cta2}
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-114">
        <span className="text-xs tracking-[0.2em] text-cream/50 uppercase" data-id="element-115">
          {t.hero.scroll}
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-116">
          <ChevronDown className="w-5 h-5 text-gold" data-id="element-117" />
        </motion.div>
      </motion.div>
    </section>;
}